import { Theme } from '../../../src/types/index.js'

export const theme: Theme = {
  id: 'classic-orange',
  name: 'Classic orange',
  palette: {
    primary: '#F57E4A',
    accent: '#00B080',
    neutral: '#F1F0ED',
  },
  light1: {
    'action-primary': '#f47f3b',
    'action-primary-hovered': '#eb6e25',
    'action-primary-pressed': '#f4620d',
    'action-primary-subdued': '#fff2e5',
    'action-primary-subdued-hovered': '#ffe1ca',
    'action-primary-subdued-pressed': '#fff1e9',
    'action-primary-disabled': '#f8f7f4',
    'action-neutral': '#FFFFFF',
    'action-neutral-hovered': '#f9f8f8',
    'action-neutral-pressed': '#f2f0ed',
    'action-neutral-subdued': '#f2f0ed',
    'action-neutral-subdued-hovered': '#e8e6e3',
    'action-neutral-subdued-pressed': '#d6d4d2',
    'action-neutral-disabled': '#FFFFFF',
    'action-destructive': '#d83028',
    'action-destructive-hovered': '#a71613',
    'action-destructive-pressed': '#840a08',
    'action-destructive-subdued': '#fff5f3',
    'action-destructive-subdued-hovered': '#fff0ec',
    'action-destructive-subdued-pressed': '#ffe0da',
    'action-destructive-disabled': '#f3f2ef',
    background: '#f3f2ef',
    'background-hovered': '#DCEEE4',
    'background-pressed': '#f6e6dd',
    'background-selected': '#e67839',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#585858',
    content: '#26190f',
    'content-subdued': '#656463',
    'content-muted': '#737270',
    'content-hovered': '#171717',
    'content-pressed': '#635548',
    'content-disabled': '#a2a29f',
    'content-on-positive': '#004b22',
    'content-on-attention': '#663200',
    'content-on-highlight': '#00265b',
    'content-on-negative': '#840a08',
    'content-on-negative-hovered': '#580202',
    'content-on-negative-pressed': '#380101',
    'content-primary': '#623315',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#f8efec',
    'content-on-destructive': '#FFFFFF',
    'content-on-interactive': '#FFFFFF',
    'content-on-background': '#26180f',
    'content-on-background-subdued': '#4a2f15',
    'content-on-background-hovered': '#171717',
    'content-on-background-pressed': '#613116',
    'content-on-background-disabled': '#a2a29f',
    interactive: '#29b88d',
    'interactive-hovered': '#13c08c',
    'interactive-pressed': '#0dcf95',
    'interactive-disabled': '#f8f7f4',
    'interactive-destructive': '#d83028',
    'interactive-destructive-hovered': '#a71613',
    'interactive-destructive-pressed': '#840a08',
    'interactive-destructive-disabled': '#f8f7f4',
    topbar: '#FFFFFF',
    'topbar-subdued': '#f3f2ef',
    'content-on-topbar': '#32302f',
    'line-on-topbar': '#d5d4d1',
    'line-on-topbar-pressed': '#574c42',
    link: '#2BAC76',
    'link-hovered': '#509b7c',
    'link-pressed': '#249264',
    line: '#d5d4d1',
    'line-subdued': '#f1efea',
    'line-hovered': '#a2a29f',
    'line-pressed': '#737270',
    'line-selected': '#545453',
    'line-disabled': '#e8e7e4',
    'line-transparent': '#0000001a',
    'line-positive': '#00612f',
    'line-positive-subdued': '#90e6af',
    'line-highlight': '#0051a8',
    'line-highlight-subdued': '#b5d7ff',
    'line-negative': '#a71613',
    'line-negative-subdued': '#ffc7bc',
    'line-negative-disabled': '#ffe0da',
    'line-attention': '#844200',
    'line-attention-subdued': '#ffcb89',
    focused: '#574c42',
    skeleton: '#e8e7e4',
    surface: '#FFFFFF',
    'surface-subdued': '#f3f2ef',
    'surface-hovered': '#fff8ec',
    'surface-subdued-hovered': '#e8e7e4',
    'surface-pressed': '#f5ecdf',
    'surface-disabled': '#f8f7f4',
    'surface-selected': '#fff3ea',
    'surface-selected-hovered': '#f5f1f5',
    'surface-selected-pressed': '#ece4eb',
    'surface-attention': '#ffe2bb',
    'surface-attention-subdued': '#fff7ed',
    'surface-negative': '#ffe0da',
    'surface-negative-subdued': '#fff5f3',
    'surface-negative-subdued-hovered': '#fff0ec',
    'surface-negative-subdued-pressed': '#ffe0da',
    'surface-positive': '#c1f2d0',
    'surface-positive-subdued': '#f2fbf5',
    'surface-highlight': '#d6e9ff',
    'surface-highlight-subdued': '#f4f9ff',
    'surface-highlight-subdued-hovered': '#e9f3ff',
    'surface-highlight-subdued-pressed': '#d6e9ff',
    'surface-neutral': '#e8e7e4',
    'surface-neutral-subdued': '#f8f7f4',
    'surface-inverse': '#171717',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  light2: {
    'action-primary': '#f47f3b',
    'action-primary-hovered': '#eb6e25',
    'action-primary-pressed': '#f4620d',
    'action-primary-subdued': '#fff2e5',
    'action-primary-subdued-hovered': '#ffe1ca',
    'action-primary-subdued-pressed': '#fff1e9',
    'action-primary-disabled': '#f8f7f4',
    'action-neutral': '#FFFFFF',
    'action-neutral-hovered': '#f9f8f8',
    'action-neutral-pressed': '#f2f0ed',
    'action-neutral-subdued': '#f2f0ed',
    'action-neutral-subdued-hovered': '#f6f2f6',
    'action-neutral-subdued-pressed': '#e8e6e3',
    'action-neutral-disabled': '#FFFFFF',
    'action-destructive': '#d83028',
    'action-destructive-hovered': '#a71613',
    'action-destructive-pressed': '#840a08',
    'action-destructive-subdued': '#fff5f3',
    'action-destructive-subdued-hovered': '#fff0ec',
    'action-destructive-subdued-pressed': '#ffe0da',
    'action-destructive-disabled': '#f3f2ef',
    background: '#FFFFFF',
    'background-hovered': '#DCEEE4',
    'background-pressed': '#78be97',
    'background-selected': '#6aa685',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#a2a29f',
    content: '#26190f',
    'content-subdued': '#4a3d33',
    'content-muted': '#737270',
    'content-hovered': '#171717',
    'content-pressed': '#635548',
    'content-disabled': '#a2a29f',
    'content-on-positive': '#004b22',
    'content-on-attention': '#663200',
    'content-on-highlight': '#00265b',
    'content-on-negative': '#840a08',
    'content-on-negative-hovered': '#580202',
    'content-on-negative-pressed': '#380101',
    'content-primary': '#623315',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#f8efec',
    'content-on-destructive': '#FFFFFF',
    'content-on-interactive': '#FFFFFF',
    'content-on-background': '#26180f',
    'content-on-background-subdued': '#4a2f15',
    'content-on-background-hovered': '#171717',
    'content-on-background-pressed': '#ecf7f1',
    'content-on-background-disabled': '#a2a29f',
    interactive: '#29b88d',
    'interactive-hovered': '#32ebb3',
    'interactive-pressed': '#2e9475',
    'interactive-disabled': '#f8f7f4',
    'interactive-destructive': '#d83028',
    'interactive-destructive-hovered': '#a71613',
    'interactive-destructive-pressed': '#840a08',
    'interactive-destructive-disabled': '#f8f7f4',
    topbar: '#ffffff',
    'topbar-subdued': '#f3f2ef',
    'content-on-topbar': '#635548',
    'line-on-topbar': '#d6d3d2',
    'line-on-topbar-pressed': '#73716f',
    link: '#39bd95',
    'link-hovered': '#32ebb3',
    'link-pressed': '#2e9475',
    line: '#d6d4d2',
    'line-subdued': '#f5f2f0',
    'line-hovered': '#a2a29f',
    'line-pressed': '#73716f',
    'line-selected': '#545453',
    'line-disabled': '#e8e7e4',
    'line-transparent': '#0000001a',
    'line-positive': '#00612f',
    'line-positive-subdued': '#90e6af',
    'line-highlight': '#0051a8',
    'line-highlight-subdued': '#b5d7ff',
    'line-negative': '#a71613',
    'line-negative-subdued': '#ffc7bc',
    'line-negative-disabled': '#ffe0da',
    'line-attention': '#844200',
    'line-attention-subdued': '#ffcb89',
    focused: '#ffdbba',
    skeleton: '#efede7',
    surface: '#ffffff',
    'surface-subdued': '#f3f2ef',
    'surface-hovered': '#f3f2ef',
    'surface-subdued-hovered': '#e8e7e4',
    'surface-pressed': '#f5ecdf',
    'surface-disabled': '#f8f7f4',
    'surface-selected': '#fff3ea',
    'surface-selected-hovered': '#f5f1f5',
    'surface-selected-pressed': '#ece4eb',
    'surface-attention': '#ffe2bb',
    'surface-attention-subdued': '#fff7ed',
    'surface-negative': '#ffe0da',
    'surface-negative-subdued': '#fff5f3',
    'surface-negative-subdued-hovered': '#fff0ec',
    'surface-negative-subdued-pressed': '#ffe0da',
    'surface-positive': '#c1f2d0',
    'surface-positive-subdued': '#f2fbf5',
    'surface-highlight': '#d6e9ff',
    'surface-highlight-subdued': '#f4f9ff',
    'surface-highlight-subdued-hovered': '#e9f3ff',
    'surface-highlight-subdued-pressed': '#d6e9ff',
    'surface-neutral': '#e8e7e4',
    'surface-neutral-subdued': '#f8f7f4',
    'surface-inverse': '#171717',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  light3: {
    'action-primary': '#f47f3b',
    'action-primary-hovered': '#eb6e25',
    'action-primary-pressed': '#f4620d',
    'action-primary-subdued': '#fff2e5',
    'action-primary-subdued-hovered': '#ffe1ca',
    'action-primary-subdued-pressed': '#fff1e9',
    'action-primary-disabled': '#f8f7f4',
    'action-neutral': '#f7f5f2',
    'action-neutral-hovered': '#ebe8e1',
    'action-neutral-pressed': '#dad7ce',
    'action-neutral-subdued': '#e8e7e4',
    'action-neutral-subdued-hovered': '#d5d4d1',
    'action-neutral-subdued-pressed': '#d5d4d1',
    'action-neutral-disabled': '#f8f7f4',
    'action-destructive': '#d83028',
    'action-destructive-hovered': '#a71613',
    'action-destructive-pressed': '#840a08',
    'action-destructive-subdued': '#fff5f3',
    'action-destructive-subdued-hovered': '#fff0ec',
    'action-destructive-subdued-pressed': '#ffe0da',
    'action-destructive-disabled': '#f3f2ef',
    background: '#FFFFFF',
    'background-hovered': '#DCEEE4',
    'background-pressed': '#f3f2ef',
    'background-selected': '#f7dfc8',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#a2a29f',
    content: '#26190f',
    'content-subdued': '#4a3d33',
    'content-muted': '#737270',
    'content-hovered': '#171717',
    'content-pressed': '#635548',
    'content-disabled': '#a2a29f',
    'content-on-positive': '#004b22',
    'content-on-attention': '#663200',
    'content-on-highlight': '#00265b',
    'content-on-negative': '#840a08',
    'content-on-negative-hovered': '#580202',
    'content-on-negative-pressed': '#380101',
    'content-primary': '#623315',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#f8efec',
    'content-on-destructive': '#FFFFFF',
    'content-on-interactive': '#FFFFFF',
    'content-on-background': '#26180f',
    'content-on-background-subdued': '#4a2f15',
    'content-on-background-hovered': '#171717',
    'content-on-background-pressed': '#ca7441',
    'content-on-background-disabled': '#a2a29f',
    interactive: '#29b88d',
    'interactive-hovered': '#32ebb3',
    'interactive-pressed': '#2e9475',
    'interactive-disabled': '#f8f7f4',
    'interactive-destructive': '#d83028',
    'interactive-destructive-hovered': '#a71613',
    'interactive-destructive-pressed': '#840a08',
    'interactive-destructive-disabled': '#f8f7f4',
    topbar: '#f3f2ef',
    'topbar-subdued': '#e8e7e4',
    'content-on-topbar': '#635548',
    'line-on-topbar': '#d5d4d1',
    'line-on-topbar-pressed': '#574c42',
    link: '#2BAC76',
    'link-hovered': '#3bda97',
    'link-pressed': '#249264',
    line: '#d5d4d1',
    'line-subdued': '#fdfcfa',
    'line-hovered': '#a2a29f',
    'line-pressed': '#737270',
    'line-selected': '#545453',
    'line-disabled': '#e8e7e4',
    'line-transparent': '#0000001a',
    'line-positive': '#00612f',
    'line-positive-subdued': '#90e6af',
    'line-highlight': '#0051a8',
    'line-highlight-subdued': '#b5d7ff',
    'line-negative': '#a71613',
    'line-negative-subdued': '#ffc7bc',
    'line-negative-disabled': '#ffe0da',
    'line-attention': '#844200',
    'line-attention-subdued': '#ffcb89',
    focused: '#574c42',
    skeleton: '#e8e7e4',
    surface: '#f6f5f2',
    'surface-subdued': '#e8e7e4',
    'surface-hovered': '#fffbf5',
    'surface-subdued-hovered': '#d5d4d1',
    'surface-pressed': '#f5ecdf',
    'surface-disabled': '#f8f7f4',
    'surface-selected': '#fff3ea',
    'surface-selected-hovered': '#f5f1f5',
    'surface-selected-pressed': '#ece4eb',
    'surface-attention': '#ffe2bb',
    'surface-attention-subdued': '#fff7ed',
    'surface-negative': '#ffe0da',
    'surface-negative-subdued': '#fff5f3',
    'surface-negative-subdued-hovered': '#fff0ec',
    'surface-negative-subdued-pressed': '#ffe0da',
    'surface-positive': '#c1f2d0',
    'surface-positive-subdued': '#f2fbf5',
    'surface-highlight': '#d6e9ff',
    'surface-highlight-subdued': '#f4f9ff',
    'surface-highlight-subdued-hovered': '#e9f3ff',
    'surface-highlight-subdued-pressed': '#d6e9ff',
    'surface-neutral': '#e8e7e4',
    'surface-neutral-subdued': '#f8f7f4',
    'surface-inverse': '#171717',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  dark1: {
    'action-primary': '#f18c52',
    'action-primary-hovered': '#f0a275',
    'action-primary-pressed': '#f97e38',
    'action-primary-subdued': '#453b32',
    'action-primary-subdued-hovered': '#4d4138',
    'action-primary-subdued-pressed': '#3d3229',
    'action-primary-disabled': '#40403f',
    'action-neutral': '#1d1b19',
    'action-neutral-hovered': '#302c28',
    'action-neutral-pressed': '#201e1c',
    'action-neutral-subdued': '#292828',
    'action-neutral-subdued-hovered': '#403f3e',
    'action-neutral-subdued-pressed': '#545453',
    'action-neutral-disabled': '#40403f',
    'action-destructive': '#bc5044',
    'action-destructive-hovered': '#90372e',
    'action-destructive-pressed': '#712821',
    'action-destructive-subdued': '#4a1712',
    'action-destructive-subdued-hovered': '#712821',
    'action-destructive-subdued-pressed': '#90372e',
    'action-destructive-disabled': '#40403f',
    background: '#181614',
    'background-hovered': '#272320',
    'background-pressed': '#3b332d',
    'background-selected': '#1f1b18',
    'background-backdrop': '#00000080',
    'background-overlay': '#00000080',
    'background-divider': '#a3a2a2',
    content: '#f8f7f5',
    'content-subdued': '#d5d4d3',
    'content-muted': '#a2a2a0',
    'content-hovered': '#f3f2f0',
    'content-pressed': '#d5d4d3',
    'content-disabled': '#737271',
    'content-on-positive': '#f4faf6',
    'content-on-attention': '#fff7f1',
    'content-on-highlight': '#f5f8fd',
    'content-on-negative': '#fff6f4',
    'content-on-negative-hovered': '#ffefec',
    'content-on-negative-pressed': '#ffdfda',
    'content-primary': '#f5f4f2',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#171717',
    'content-on-destructive': '#f8f7f5',
    'content-on-interactive': '#f8f7f5',
    'content-on-background': '#f8f7f5',
    'content-on-background-subdued': '#d3d1cc',
    'content-on-background-hovered': '#f3f2f0',
    'content-on-background-pressed': '#FBFAF7',
    'content-on-background-disabled': '#737271',
    interactive: '#2EB67D',
    'interactive-hovered': '#37d291',
    'interactive-pressed': '#28a26f',
    'interactive-disabled': '#171717',
    'interactive-destructive': '#bc5044',
    'interactive-destructive-hovered': '#90372e',
    'interactive-destructive-pressed': '#712821',
    'interactive-destructive-disabled': '#171717',
    topbar: '#1d1b19',
    'topbar-subdued': '#23211e',
    'content-on-topbar': '#f8f7f5',
    'line-on-topbar': '#40403f',
    'line-on-topbar-pressed': '#737271',
    link: '#2EB67D',
    'link-hovered': '#37d291',
    'link-pressed': '#28a26f',
    line: '#403f3e',
    'line-subdued': '#40403f',
    'line-hovered': '#545453',
    'line-pressed': '#737271',
    'line-selected': '#545453',
    'line-disabled': '#40403f',
    'line-transparent': '#ffffff1a',
    'line-positive': '#051b0e',
    'line-positive-subdued': '#051b0e',
    'line-highlight': '#051730',
    'line-highlight-subdued': '#051730',
    'line-negative': '#2f0b08',
    'line-negative-subdued': '#2f0b08',
    'line-negative-disabled': '#712821',
    'line-attention': '#241304',
    'line-attention-subdued': '#241304',
    focused: '#a2826a',
    skeleton: '#40403f',
    surface: '#1d1b19',
    'surface-subdued': '#332e2a',
    'surface-hovered': '#423b36',
    'surface-subdued-hovered': '#595149',
    'surface-pressed': '#595049',
    'surface-disabled': '#40403f',
    'surface-selected': '#453b32',
    'surface-selected-hovered': '#6b5a4a',
    'surface-selected-pressed': '#6b574a',
    'surface-attention': '#3c220a',
    'surface-attention-subdued': '#5b3814',
    'surface-negative': '#4a1712',
    'surface-negative-subdued': '#712821',
    'surface-negative-subdued-hovered': '#90372e',
    'surface-negative-subdued-pressed': '#90372e',
    'surface-positive': '#0b2e1a',
    'surface-positive-subdued': '#17492d',
    'surface-highlight': '#0d284c',
    'surface-highlight-subdued': '#1b4071',
    'surface-highlight-subdued-hovered': '#27548f',
    'surface-highlight-subdued-pressed': '#27548f',
    'surface-neutral': '#423c36',
    'surface-neutral-subdued': '#40403f',
    'surface-inverse': '#f8f7f5',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  dark2: {
    'action-primary': '#f18c52',
    'action-primary-hovered': '#f0a275',
    'action-primary-pressed': '#f97e38',
    'action-primary-subdued': '#453b32',
    'action-primary-subdued-hovered': '#4d4138',
    'action-primary-subdued-pressed': '#3d3229',
    'action-primary-disabled': '#40403f',
    'action-neutral': '#181614',
    'action-neutral-hovered': '#1e1c19',
    'action-neutral-pressed': '#1c1917',
    'action-neutral-subdued': '#292828',
    'action-neutral-subdued-hovered': '#40403f',
    'action-neutral-subdued-pressed': '#545453',
    'action-neutral-disabled': '#292828',
    'action-destructive': '#bc5044',
    'action-destructive-hovered': '#90372e',
    'action-destructive-pressed': '#712821',
    'action-destructive-subdued': '#4a1712',
    'action-destructive-subdued-hovered': '#712821',
    'action-destructive-subdued-pressed': '#90372e',
    'action-destructive-disabled': '#40403f',
    background: '#1d1b19',
    'background-hovered': '#49403a',
    'background-pressed': '#3b332d',
    'background-selected': '#2d2722',
    'background-backdrop': '#00000080',
    'background-overlay': '#00000080',
    'background-divider': '#a2a2a0',
    content: '#f8f7f5',
    'content-subdued': '#d5d4d3',
    'content-muted': '#a2a2a0',
    'content-hovered': '#f3f2f0',
    'content-pressed': '#d5d4d3',
    'content-disabled': '#737271',
    'content-on-positive': '#f4faf6',
    'content-on-attention': '#fff7f1',
    'content-on-highlight': '#f5f8fd',
    'content-on-negative': '#fff6f4',
    'content-on-negative-hovered': '#ffefec',
    'content-on-negative-pressed': '#ffdfda',
    'content-primary': '#f5f4f2',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#171717',
    'content-on-destructive': '#f8f7f5',
    'content-on-interactive': '#f8f7f5',
    'content-on-background': '#f8f7f5',
    'content-on-background-subdued': '#d3d1cc',
    'content-on-background-hovered': '#f8f7f5',
    'content-on-background-pressed': '#FBFAF7',
    'content-on-background-disabled': '#737271',
    interactive: '#2EB67D',
    'interactive-hovered': '#37d291',
    'interactive-pressed': '#28a26f',
    'interactive-disabled': '#171717',
    'interactive-destructive': '#bc5044',
    'interactive-destructive-hovered': '#90372e',
    'interactive-destructive-pressed': '#712821',
    'interactive-destructive-disabled': '#171717',
    topbar: '#181614',
    'topbar-subdued': '#0d0c0b',
    'content-on-topbar': '#f8f7f5',
    'line-on-topbar': '#40403f',
    'line-on-topbar-pressed': '#737271',
    link: '#2EB67D',
    'link-hovered': '#37d291',
    'link-pressed': '#28a26f',
    line: '#40403f',
    'line-subdued': '#40403f',
    'line-hovered': '#545453',
    'line-pressed': '#737271',
    'line-selected': '#545453',
    'line-disabled': '#40403f',
    'line-transparent': '#ffffff1a',
    'line-positive': '#051b0e',
    'line-positive-subdued': '#051b0e',
    'line-highlight': '#051730',
    'line-highlight-subdued': '#051730',
    'line-negative': '#2f0b08',
    'line-negative-subdued': '#2f0b08',
    'line-negative-disabled': '#712821',
    'line-attention': '#241304',
    'line-attention-subdued': '#241304',
    focused: '#a2826a',
    skeleton: '#40403f',
    surface: '#181614',
    'surface-subdued': '#332e2a',
    'surface-hovered': '#423b36',
    'surface-subdued-hovered': '#595149',
    'surface-pressed': '#595049',
    'surface-disabled': '#292828',
    'surface-selected': '#4d4741',
    'surface-selected-hovered': '#6b5a4a',
    'surface-selected-pressed': '#6b574a',
    'surface-attention': '#3c220a',
    'surface-attention-subdued': '#5b3814',
    'surface-negative': '#4a1712',
    'surface-negative-subdued': '#712821',
    'surface-negative-subdued-hovered': '#90372e',
    'surface-negative-subdued-pressed': '#90372e',
    'surface-positive': '#0b2e1a',
    'surface-positive-subdued': '#17492d',
    'surface-highlight': '#0d284c',
    'surface-highlight-subdued': '#1b4071',
    'surface-highlight-subdued-hovered': '#27548f',
    'surface-highlight-subdued-pressed': '#27548f',
    'surface-neutral': '#423c36',
    'surface-neutral-subdued': '#40403f',
    'surface-inverse': '#f8f7f5',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
}
